var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[_vm.name],style:(_vm.mainCssVars)},[_c('grid',{class:[{ 'grid--container': !_vm.fullwidth }, `${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        gap: '6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        gap: '10px',
      },
    ]}},[_c('grid-item',{class:[`${_vm.name}__grid-item`, `${_vm.name}__grid-content`],attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 1, width: 24 },
      ]}},[(_vm.cms.media_heading)?_c('a-heading',{class:`${_vm.name}__heading`,attrs:{"cms":{ heading: _vm.cms.media_heading },"html-tag":"h4"}}):_vm._e(),_vm._v(" "),_c('m-slide-v2',{attrs:{"cms":_vm.cms}}),_vm._v(" "),(_vm.cms.media_copy)?_c('div',{class:`${_vm.name}__caption`,domProps:{"innerHTML":_vm._s(_vm.$options.filters.markdown(_vm.cms.media_copy))}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }